import React from 'react';
import T from 'i18n-react';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

const MemoHelperText = () => {
  return (
    <div>
      <Typography variant="body2" gutterBottom>
        {T.translate('applicant.new.memoHelperText.message1')}
      </Typography>
      <Ul>
        <Typography variant="body2" component="li">
          {T.translate('applicant.new.memoHelperText.message2')}
        </Typography>
        <Typography variant="body2" component="li">
          {T.translate('applicant.new.memoHelperText.message3')}
        </Typography>
        <Typography variant="body2" component="li">
          {T.translate('applicant.new.memoHelperText.message4')}
        </Typography>
      </Ul>
    </div>
  );
};

export default MemoHelperText;

const Ul = styled.ul(
  ({ theme }) => `
  padding-left: ${theme.spacing(3)}px;
  margin-bottom: 0;
`,
);
